import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { IAttribute, IModel } from '../base/annotation';

@Metamodel.model({})
export class LogicAppsProperty extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly NAME: IAttribute;

    public name: string;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['Any'],
        association: 'VALUE'
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public value: any;
    public in?: string;
    public description: string;
    public type: string;
    public label: string;
    public format: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public options?: any[]; // Array<ISelectOption<String>>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectedOptions?: any[];
    public visibility?: string;
    public required: boolean;
    public showRefresh?: boolean;
    public minimum?: number;
    public children: LogicAppsProperty[];
    public loading: boolean = false;
    public loadingChildren: boolean = false;
    public loadingMessage: string = '';
    public dynamicExtension?: IDynamicValuesExtension;
    public schemaDynamicExtension?: IDynamicValuesExtension;
    public dynamicTreeExtension?: IDynamicTreeExtension;
    public emptyResultWarningMessage?: string;
    public selectedValueDontExistErrorMessage?: string;
    public placeHolderText?: string;
}

export interface IDynamicValuesExtension {
    operation?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parameters: Record<string, any>;
    collection: string;
    valuePath: string;
    valuePathRegex?: string;
    valuePathRegexPos?: string;
    valueTitle: string;
    valueTitleRegex?: string;
    valueTitleRegexPos?: string;
}

export interface IDynamicTreeExtension {
    settings: {
        canSelectParentNodes: boolean;
        canSelectLeafNodes: boolean;
    };
    open: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parameters: Record<string, any>;
    };
    browse: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parameters: Record<string, any>;
    };
}

export interface IContainerPath {
    id: string;
    path: string;
    name: string;
    folders: IContainerPath[];
}

export interface ITableOption {
    label: string
    value: string;
    extendedProperties?: IExtendedProperties
}

export interface IExtendedProperties {
    options: string[];
}

export interface IRefreshTable {
    table: string;
    partition?: string;
}
